import { AnyAction } from "redux";

import { GetReportsType, GetReportsProductsType, UpdateReportForm, GetReportDetail, UpdateReportValidationObject, UpdateValidationObject, UpdateReportIsFetchingState, UpdateFinalReportFormData, UpdateIsExportReport, ResetReportFilter } from "../actions/actionTypes";
import { updateObject } from "../../services/utilService";

const initialState = {
    reportsType: [],
    reportsProductsType: [],
    reportForm: {
        reportEnum: 1,
        productTypeFilter: 0,
        from: null,
        to: null,
        exportType: 1,
    },
    validations: {
        from: {
            required: false,
            isDate: true,
            lessThanOrEqualTo: 'to',
            isValid: false,
            errorMessage: {
                invalid: '',
                min: ''
            }
        },
        to: {
            required: false,
            isDate: true,
            greaterThanOrEqualTo: 'from',
            isValid: false,
            errorMessage: {
                invalid: '',
                max: ''
            }
        }
    },
    reportDetail: null,
    isFetching: null,
    finalReportFormData: {
        reportEnum: 1,
        productTypeFilter: 0,
        from: null,
        to: null,
        exportType: 1,
    },
    isExportingReport: null
}

const getReportsType = (state, action) => {
    return updateObject(state, {
        reportsType: action
    });
}

const getReportsProductsType = (state, action) => {
    return updateObject(state, {
        reportsProductsType: action
    });
}

const updateReportForm = (state, action) => {
    return updateObject(state, {
        reportForm: {
            ...state.reportForm,
            ...action
        }
    });
}

const getReportDetail = (state, action) => {
    return updateObject(state, {
        reportDetail: action
    })
}

const updateValidationObj = (state, action) => {
    return updateObject(state, Object.assign({}, {
        validations: action
    }))
}

const updateIsFetchingState = (state, action) => {
    return updateObject(state, {
        isFetching: action
    })
}

const updateFinalReportFormData = (state, action) => {
    return updateObject(state, {
        finalReportFormData: action
    });
}

const updateIsExportingReport = (state, action) => {
    return updateObject(state, {
        isExportingReport: action
    })
}

const resetReportFilter = (state) => {
    return updateObject(state, {
        reportForm: initialState.reportForm,
        finalReportFormData: initialState.finalReportFormData,
        reportDetail: null,
        isFetching: null,
        validations: {
            ...initialState.validations,
            from: {
                ...initialState.validations.from,
                errorMessage: {}
            },
            to: {
                ...initialState.validations.to,
                errorMessage: {}
            }
        }
    })
}

const reportsReducer = (state = initialState, action: AnyAction) => {
    switch(action.type) {
        case ResetReportFilter: return resetReportFilter(state);
        case UpdateIsExportReport: return updateIsExportingReport(state, action.payload);
        case UpdateFinalReportFormData: return updateFinalReportFormData(state, action.payload);
        case GetReportsType: return getReportsType(state, action.payload);
        case GetReportsProductsType: return getReportsProductsType(state, action.payload);
        case UpdateReportForm: return updateReportForm(state, action.payload);
        case GetReportDetail: return getReportDetail(state, action.payload);
        case UpdateReportValidationObject: return updateValidationObj(state, action.payload);
        case UpdateReportIsFetchingState: return updateIsFetchingState(state, action.payload);
        default: return state;
    }
}

export default reportsReducer;